module.exports = __webpack_public_path__ + "static/img/logo_4039.2488ab1a.png";